import { Card } from 'antd';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import TableReturn from '../components/TableReturn';
const Breadcrumb = [
  {
    tittle: 'Retransfer/Disposal ',
    url: ''
  },
  {
    tittle: 'Retransfer/Disposal List ',
    url: ''
  }
];

const ReturnPage = () => {
  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <TableReturn />
        </Card>
      </div>
    </>
  );
};

export default ReturnPage;
